import React from 'react';
import PropTypes from 'prop-types';

const getFormatter = (currency, showDecimals) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: showDecimals ? 2 : 0,
  });

const Currency = ({
  currency = 'USD',
  className = '',
  children,
  'data-xc': dataXc,
  'data-name': dataName,
}) => {
  // Forward test/analytics hooks to the rendered element so callers passing
  // data-xc/data-name (e.g. price sections) are actually targetable in the DOM.
  const dataAttrs = {};
  if (dataXc) dataAttrs['data-xc'] = dataXc;
  if (dataName) dataAttrs['data-name'] = dataName;

  if (
    typeof children === 'undefined' ||
    children === null ||
    Number.isNaN(children)
  ) {
    return <span className={`Currency ${className}`} {...dataAttrs} />;
  }

  const showDecimals = parseInt(children, 10) !== parseFloat(children);
  const currencyString = getFormatter(currency, showDecimals).format(children);

  return (
    <span className={`Currency ${className}`} {...dataAttrs}>
      {currencyString}
    </span>
  );
};

Currency.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  currency: PropTypes.string,
  'data-xc': PropTypes.string,
  'data-name': PropTypes.string,
};

export default Currency;
